import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackageExpiryReportContent from "./PackageExpiryReportContent";

const PackageExpiryPage = () => (
  <PackageExpiryReportContent
    type="paket"
    title={translate("analyticsPage.package.report_status")}
    backTo={PATHS.ANALYTICS}
  />
);

export default PackageExpiryPage;
